import React from "react";
import { Popover, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  emojiContainer: {
    padding: theme.spacing(1),
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gap: "2px",
    maxWidth: "320px",
    // Barras de rolagem apenas em mobile
    [theme.breakpoints.down('sm')]: {
      maxHeight: "280px",
      overflowX: "auto",
      overflowY: "auto",
    },
    // Estilização da scrollbar (apenas mobile)
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.background.default,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: theme.palette.action.active,
      },
    },
  },
  emoji: {
    fontSize: "24px",
    cursor: "pointer",
    padding: "2px",
    borderRadius: "4px",
    textAlign: "center",
    transition: "all 0.2s",
    userSelect: "none",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.2)",
    },
  },
}));

const commonEmojis = [
  "👍", "❤️", "😂", "😮", "😢", "🙏",
  "👏", "🔥", "🎉", "💯", "✅", "❌",
  "😊", "😍", "🤔", "😎", "🤩", "😭",
  "😡", "🤗", "🥰", "😘", "🤪", "😴",
  "👀", "💪", "🙌", "🤝", "✨", "⭐",
  "💚", "💙", "💜", "🧡", "💛", "🖤",
  "☺️", "😁", "🤣", "😉", "😇", "🥺",
  "🙄", "😏", "😱", "🤯", "😬", "🤐"
];

const EmojiPicker = ({ open, anchorEl, onClose, onEmojiSelect }) => {
  const classes = useStyles();

  const handleEmojiClick = (emoji) => {
    onEmojiSelect(emoji);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <div className={classes.emojiContainer}>
        {commonEmojis.map((emoji, index) => (
          <span
            key={index}
            className={classes.emoji}
            onClick={() => handleEmojiClick(emoji)}
            role="button"
            aria-label={`emoji ${emoji}`}
          >
            {emoji}
          </span>
        ))}
      </div>
    </Popover>
  );
};

export default EmojiPicker;
